export default "__VITE_ASSET__DIhQsOYr__"